import { ShippingLocation_ } from 'src/api/db/apiShippingLocations'

export const formatContactInfo = (location: ShippingLocation_): string => {
  const contactParts: string[] = []
  if (location.first_name || location.last_name) {
    contactParts.push(
      [location.first_name, location.last_name].filter(Boolean).join(' ')
    )
  }
  if (location.phone_number) {
    contactParts.push(location.phone_number)
  }
  return contactParts.join(' • ')
}

